import { ParagraphSectionLayout, ParagraphTitle } from "@frontend/common";

import { DEALS_PARAGRAPH_CODE } from "@EditArticleContainer/shared/constants/editArticle.constants";
import { useParagraphEditedData } from "@EditArticleContainer/shared/hooks/useParagraph";
import { useUpdateParagraph } from "@EditArticleContainer/shared/hooks/useUpdateParagraph";
import { RightsScopeTableItem } from "@EditArticleContainer/shared/types/paragraphContents/contents/keyRightsLASCContent.types";

import KeyRightsLASCTableGroup from "./components/KeyRightsLASCTableGroup/KeyRightsLASCTableGroup";
import * as S from "./DealsParagraphKeyRightsLASC.style";

const PARAGRAPH_TITLE = "Key Rights";

const getFlowKey = (item: RightsScopeTableItem): string => {
  const contributing = item["Rights Flow"]["Contributing Axis"].value
    .map((v) => v.text ?? "")
    .filter(Boolean)
    .sort()
    .join(",");
  const benefiting = item["Rights Flow"]["Benefiting Axis"].value
    .map((v) => v.text ?? "")
    .filter(Boolean)
    .sort()
    .join(",");
  return `${contributing}→${benefiting}`;
};

type GroupedItem = { item: RightsScopeTableItem; index: number };

const groupByFlow = (items: RightsScopeTableItem[]): GroupedItem[][] => {
  const groups: GroupedItem[][] = [];
  const keyIndexMap = new Map<string, number>();

  items.forEach((item, index) => {
    const key = getFlowKey(item);
    const groupIndex = keyIndexMap.get(key);
    if (groupIndex !== undefined) {
      groups[groupIndex].push({ item, index });
    } else {
      keyIndexMap.set(key, groups.length);
      groups.push([{ item, index }]);
    }
  });

  return groups;
};

const DealsParagraphKeyRightsLASC = () => {
  const paragraph = useParagraphEditedData(DEALS_PARAGRAPH_CODE.keyRightsLASC);
  const [updateParagraph, loadingIndex, updateKeyMap] = useUpdateParagraph({
    paragraphCode: DEALS_PARAGRAPH_CODE.keyRightsLASC,
    sectionCode: "TY002",
  });

  if (!paragraph) return null;

  // NOTE:  Asset 값이 없으면 테이블에서 제외
  const rightsScopeTable = paragraph.text["Rights Scope Table"].filter(
    (rightsScopeData) =>
      rightsScopeData.Asset.value.some((v) => (v.text ?? "").trim() !== ""),
  );

  if (rightsScopeTable.length === 0) return null;

  const groups = groupByFlow(rightsScopeTable);

  return (
    <ParagraphSectionLayout className="sub-section-wrapper">
      <ParagraphTitle title={PARAGRAPH_TITLE} type="section" />
      <S.ParagraphKeyRightsLASCWrapper key={updateKeyMap.get(0)}>
        <S.ParagraphKeyRightsLASCUpdateButton
          disabled={loadingIndex === 0}
          onClick={() => updateParagraph(0)}
        />
        {groups.map((group, groupIndex) => (
          <KeyRightsLASCTableGroup
            key={`key-rights-lasc-group-${String(groupIndex)}`}
            items={group}
          />
        ))}
      </S.ParagraphKeyRightsLASCWrapper>
    </ParagraphSectionLayout>
  );
};

export default DealsParagraphKeyRightsLASC;
